package core.dateformat.ui

data class DateTimeState(
    val selectedDateFormat: String = "",
)
